import React, {useEffect, useState} from "react";
import {Card, CardBody, CardHeader, Divider, NextUIProvider} from "@nextui-org/react";
import Header from './components/Header';
import Footer from './components/Footer'
import Form from "./components/Form";
import Result from "./components/Result";
import './index.css';
import FormNosocios from "./components/FormNosocios";



function App() {
    const [values,setValues] = useState({});
    const [results,setResults] = useState(false);

    useEffect(() => {
        (typeof values !== "undefined" && values !== null && Object.keys(values).length) ? setResults(true) : setResults(false);
        results ? console.log("true") : console.log(results);
    }, [values]);


    return(
      <NextUIProvider>
          <div>
              <Header/>
              <Card className="form-wrapper">
                  <CardHeader className="flex gap-3 p-4">
                      <div className="flex flex-col">
                          {
                              results ?
                                  <h1>Resultado de tu simulación</h1> : <h1>Simulá tu Ayuda Económica</h1>
                          }
                      </div>
                  </CardHeader>
                  <Divider/>
                  <CardBody className="formBody p-4">
                      {
                            results ?
                                <Result passValues={values} getRefresh={setResults} /> : <Form getValues={setValues} />
                      }
                  </CardBody>
              </Card>
            <Footer/>
          </div>
      </NextUIProvider>
  );
}

export default App;
